import { render, staticRenderFns } from "./NewsPageMobile.vue?vue&type=template&id=6ab6ed76&"
import script from "./NewsPageMobile.vue?vue&type=script&lang=js&"
export * from "./NewsPageMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewsPageMobile.vue?vue&type=style&index=0&id=6ab6ed76&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports